import type React from 'react';

export function hasVisibleText(value?: string | null): boolean {
  return Boolean(value?.trim());
}

export function renderHeading(
  Tag: 'h2' | 'h3' | 'h4',
  value?: string | null,
  className?: string,
): React.ReactNode {
  const text = value?.trim();
  if (!text) return null;
  return <Tag className={className}>{text}</Tag>;
}

export function getLexicalChildrenText(children?: unknown[]): string {
  if (!Array.isArray(children)) {
    return '';
  }

  return children
    .map((child) => {
      if (!child || typeof child !== 'object') {
        return '';
      }

      const node = child as { type?: string; text?: string; children?: unknown[] };

      if (node.type === 'text') {
        return node.text ?? '';
      }

      if (Array.isArray(node.children)) {
        return getLexicalChildrenText(node.children);
      }

      return node.text ?? '';
    })
    .join('');
}
